import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import authService from "../../services/authService";
import { showToast } from "../../utils/showToast";
import "../../styles/dashboardTheme.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      showToast({ type: "warning", message: "Todos los campos son obligatorios" });
      return;
    }

    setLoading(true);

    try {
      const data = await authService.login({ identifier: email, password });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      showToast({ type: "success", message: "Inicio de sesión exitoso" });
      setTimeout(() => navigate("/dashboard/view_dashboard"), 800);
    } catch (error) {
      const msg = error?.data?.message || error.message || "Error de conexión con el servidor";
      showToast({ type: "danger", message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="text-center mb-4">
          <span className="dashboard-eyebrow d-inline-block mb-1">ADEMY</span>
          <h2 className="auth-title mb-2">Iniciar sesión</h2>
          <p className="auth-subtitle">Ingresa tus credenciales para continuar</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="auth-form-group">
            <label htmlFor="email" className="form-label dashboard-label">
              Correo o usuario
            </label>
            <input
              type="text"
              id="email"
              className="form-control auth-input"
              placeholder="usuario@correo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="auth-form-group">
            <label htmlFor="password" className="form-label dashboard-label">
              Contraseña
            </label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className="form-control auth-input"
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                tabIndex="-1"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`} />
              </button>
            </div>
          </div>

          <button type="submit" className="btn dashboard-btn-primary w-100" disabled={loading}>
            {loading ? "Iniciando sesión..." : "Ingresar"}
          </button>

          <div className="auth-extra">
            <div className="mb-2">
              <Link to="/requestPassword" className="auth-link">
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
            {/* <div className="auth-helper">
              ¿No tienes cuenta? <Link to="/register" className="auth-link">Crear una</Link>
            </div> */}
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
